export default () => ({
	slidesPerPage: 0,
	currentPage: 0,
	totalPages: 0,

	get slides() {
		return Array.from(this.$refs.slider.querySelectorAll('li')).filter(element => element.clientWidth > 0);
	},

	init() {
		if (!this.$refs.slider) return;

		this.update();

		const resizeObserver = new ResizeObserver(() => this.update());
		resizeObserver.observe(this.$refs.slider);
	},

	update() {
		if (!this.slides.length) return;

		this.slidesPerPage = Math.floor(this.$refs.slider.clientWidth / this.slides[0].clientWidth);
		this.currentPage = Math.round(this.$refs.slider.scrollLeft / this.slides[0].clientWidth) + 1;
		this.totalPages = this.slides.length - this.slidesPerPage + 1;
	},

	slider: {
		['@scroll.passive']() {
			this.update();
		},
	},

	next: {
		['@click.prevent']() {
			if (!this.slides.length) return;

			this.$refs.slider.scrollTo({
				left: this.$refs.slider.scrollLeft + this.slides[0].clientWidth,
			})
		},
		[':disabled']() {
			return this.currentPage === this.totalPages;
		},
	},

	previous: {
		['@click.prevent']() {
			if (!this.slides.length) return;

			this.$refs.slider.scrollTo({
				left: this.$refs.slider.scrollLeft - this.slides[0].clientWidth,
			})
		},
		[':disabled']() {
			return this.currentPage === 1;
		},
	},
})
